import { createSlice } from '@reduxjs/toolkit';

export const ApiStatusKeys = {
  REGISTER: 'auth/register',
  LOGIN: 'auth/login',
  UPLOAD_IMAGE: 'auth/upload-image',
  LOGOUT: 'auth/logout',
  UPDATE_USER_PROFILE: 'user/update-user-profile',
  UPDATE_COACHING_PROFILE: 'user/update-coaching-profile',
  UPDATE_COACHING_CERTIFICATES: 'user/update-coaching-certificates',
  REGISTER_TOKEN: 'auth/register-token',
  REFINE_COACH_INFO: 'ai/refine',
  GET_CATEGORIES: 'category/get-categories',
  SEARCH: 'search/search',
  GET_COACH: '/coach/get-coach-by-id',
  GET_CATEGORY: 'category/get-category-by-id',
  FORGET_PASSWORD: 'auth/reset-password-request',
  RESET_PASSWORD: 'auth/reset-password',
  ACTIVATE_USER: 'auth/activate-user',
  VERIFY_ACCOUNT: 'auth/verify-account',
  IS_USER_EXIST: 'auth/is-user-exist',
  DELETE_USER: 'auth/delete-user-account',
  // Admin API Keys
  ADMIN_GET_DASHBOARD_STATS: 'admin/get-dashboard-stats',
  ADMIN_GET_USERS: 'admin/user/search',
  ADMIN_GET_LAST_USERS: 'admin/user/last',
  ADMIN_DELETE_USER: 'admin/user/delete',
  ADMIN_GET_USER_BY_ID: 'admin/user/get-by-id',
  ADMIN_UPDATE_USER: 'admin/user/update',
  // Admin Category API Keys
  ADMIN_CREATE_CATEGORY: 'admin/category/create',
  ADMIN_UPDATE_CATEGORY: 'admin/category/update',
  ADMIN_DELETE_CATEGORY: 'admin/category/delete',
  ADMIN_SET_EMBEDDINGS_CATEGORY: 'admin/category/embedded-categories',
};

const initialState = {};

const apiStatusSlice = createSlice({
  name: 'apiStatus',
  initialState,
  reducers: {
    setApiLoading: (state, action) => {
      state[action.payload] = {
        loading: true,
        success: false,
        error: null,
        timestamp: Date.now(),
      };
    },
    setApiSuccess: (state, action) => {
      const key = action.payload.key || action.payload;
      const redirectUrl = action.payload.redirectUrl;

      state[key] = {
        loading: false,
        success: true,
        error: null,
        redirectUrl,
      };
    },
    setApiError: (state, action) => {
      state[action.payload.key] = {
        loading: false,
        success: false,
        error: action.payload.error,
        timestamp: Date.now(),
      };
    },
    clearApiStatus: (state, action) => {
      delete state[action.payload];
    },
  },
});

export const { setApiLoading, setApiSuccess, setApiError, clearApiStatus } = apiStatusSlice.actions;
export default apiStatusSlice.reducer;
